import * as React from "react";

import { useState, useEffect } from "react";

import { reduxForm, getFormValues, Field, change } from "redux-form";

import { connect } from "react-redux";

import { Row, Col, Card, CardBody } from "reactstrap";

import { Button } from "reactstrap";

import TextField from "../../commonfields/TextField";

import SelectField from "../../commonfields/SelectField";

import NormaliseExt from "../../utils/NormaliseExt";

import SpinnerModel from "../../commonfields/SpinnerModel";

import normaliseZipcode from "../../utils/normaliseZipCode";

import Service from "../../services";

import { catchError } from "../../utils/Utils";

import { AxiosError, AxiosResponse } from "axios";

// import validate from "../layout/Leads/NewLead/Validate";

import validate from "./Validate";
import warn from "../layout/Leads/NewLead/FieldErrors";
import EmailTextField from "../../commonfields/EmailTextField";
import ValidateSelectField from "../../commonfields/ValidateSelectField";
import { State, Suggestion, suggestions } from "../layout/Leads/LeadDetails";
import PhoneNumberField from "../../commonfields/PhoneNumberfield";

const EditCompanyInfoForm: React.FC = (props: any) => {
  const [loader, setLoader] = useState<boolean>(false);

  const [phoneType, setPhoneType] = useState([]);

  const [emailType, setEmailType] = useState([]);

  const [industryType, setIndustryType] = useState([]);

  const [states, setStates] = useState<State[]>([]);

  const [industrySubType, setIndustrySubType] = useState([]);

  const [checkEmail, setEmailCheck] = useState(false);

  const [suggestionsData, setSuggestions] = useState<any>();

  const [suggestionsBox, setSuggestionsBox] = useState<boolean>(false);

  const [disableAddress, setDisableAddress] = useState(true);

  const service = new Service();

  const getDropwowndata = () => {
    let payload = {
      screen: "ProspectDetails",

      sections: "BusinessInfoEditDropdownsList",

      isJsonReturnObject: true,
    };

    service

      .getLeadsData(payload)

      .then((res: any) => {
        setStates(res.data[0]?.states);

        setEmailType(res.data[0]?.emailtypes);

        setPhoneType(res.data[0]?.phonetypes);

        setIndustryType(res.data[0]?.industrytypes);     
        if(props.data.industryType){
          const temp: any = res.data[0]?.industrytypes?.find((i: any) => i.value === props.data.industryType);
          setIndustrySubType(temp?.industrySubTypes || []);
        }
        // setIndustrySubType(res.data[0]?.industrytypes[0]?.industrySubTypes);
      })

      .catch((error: AxiosError) => {
        catchError(error, true);
      });
  };

  const EmailCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    const error =
      value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? false
        : true;

    setEmailCheck(error);
  };

  const streetAddress = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisableAddress(false);

    props.change("businessZipCode", "");

    props.change("businessCity", "");

    props.change("businessState", "");

    if (event.target.value !== "") {
      await service

        .getAddressSuggestions(event.target.value)

        .then((response: AxiosResponse<suggestions>) => {
          if (
            response.data.suggestions.length != 0 &&
            event.target.value != ""
          ) {
            setSuggestions(response.data);

            setSuggestionsBox(true);
          } else {
            setSuggestions([]);

            setSuggestionsBox(false);
          }
        })

        .catch((error: AxiosError) => catchError(error, true));
    } else {
      setSuggestions(null);

      setSuggestionsBox(false);
    }
  };

  const selectedValue = (indexValue: any) => {
    const suggestionValue = suggestionsData?.suggestions[indexValue];

    props.change("businessStreetAddress", suggestionValue?.street_line);

    props.change("businessCity", suggestionValue?.city);

    props.change("businessZipCode", suggestionValue?.zipcode);

    const stateId = states?.find(
      (m: any) => m.text == suggestionValue?.state
    )?.value;

    props.change("businessState", stateId);

    setSuggestionsBox(false);

    setDisableAddress(true);
  };

  const onStreetAddressBlur = () => {
    setTimeout(() => {
      setSuggestionsBox(false);

      setSuggestions(null);
    }, 500);
  };

  useEffect(() => {
    getDropwowndata();
  }, []);

  //   useEffect(() => {

  // if(props?.formValues?.businessPhoneNumber)

  //  {   props.dispatch(change("EditCompanyInfoForm",`businessPhoneNumber`)) }

  //  if(){   props.dispatch(change("EditCompanyInfoForm", `${fieldName}.isPrimary`))}

  // }, [props?.formValues?.businessPhoneNumber||props?.formValues?.businessEmail]);

  const onChangeIndustryType = (e: any) => {
    const temp: any = industryType.find((i: any) => i.value === e);
    setIndustrySubType(temp?.industrySubTypes || []);
  };

  return (
    <>
      {loader ? (
        <SpinnerModel value={""} color={"primary"} size={""} type={"border"} />
      ) : (
        ""
      )}

      <form
        autoComplete="off"
        className="editCompanyIfo"
        onSubmit={(e: any) => props.handleFormSubmit(e, props.formValues)}
      >
        <Card>
          <CardBody>
            <div>
              <div className="contactInfoRow">
                <Row>
                  <Col md="12" className="biz-label">
                    <Field
                      name="businessName"
                      component={TextField}
                      disabled={true}
                      type="text"
                      label="Business Name"
                      helpText="businessName"
                      isRequired
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="9" style={{ paddingRight: "0" }}>
                    <Field
                      name="businessStreetAddress"
                      component={TextField}
                      type="text"
                      label="Street Address"
                      helpText="streetAddress"
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        streetAddress(event)
                      }
                      onBlur={() => onStreetAddressBlur()}
                      autoComplete="nope"
                    />

                    {suggestionsBox && suggestionsData !== null ? (
                      <div className="suggestionsbox">
                        {suggestionsData?.suggestions?.map(
                          (m: Suggestion, index: number) => (
                            <>
                              <p
                                className="suggestionsContent"
                                onClick={() => selectedValue(index)}
                              >
                                {m.street_line},{m.city},{m.state},{m.zipcode}
                              </p>
                            </>
                          )
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </Col>

                  <Col md="3">
                    <Field
                      name="businessUnitSuite"
                      className="unitSuite"
                      component={TextField}
                      type="text"
                      label="Unit,Suite,etc."
                      helpText="Unit,Suite,etc."
                    />
                  </Col>
                </Row>

                <Row className="">
                  <Col md="4" style={{ paddingRight: "0" }}>
                    <Field
                      name="businessCity"
                      component={TextField}
                      type="text"
                      label="City"
                      helpText="city"
                      disabled={disableAddress}
                    />
                  </Col>

                  <Col md="4" style={{ paddingRight: "0" }}>
                    <Field
                      name="businessState"
                      component={SelectField}
                      type="text"
                      label="State"
                      values={states}
                      helpText="State"
                      disabled={disableAddress}
                    />
                  </Col>

                  <Col md="4">
                    <Field
                      name="businessZipCode"
                      component={TextField}
                      label="Zip Code"
                      helpText="zipCode"
                      normalize={normaliseZipcode}
                      disabled={disableAddress}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="6" style={{ paddingRight: "0" }}>
                    <Field
                      name="industryType"
                      component={SelectField}
                      values={industryType}
                      type="text"
                      label="Industry Type"
                      helpText="industryType"
                      onChange={onChangeIndustryType}
                    />
                  </Col>

                  <Col md="6">
                    <Field
                      name="industrySubType"
                      component={SelectField}
                      values={industrySubType}
                      type="text"
                      label="Industry Subtype"
                      helpText="industrySubtype"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md="8" style={{ paddingRight: "0" }}>
                    <Field
                      name="businessEmail"
                      component={EmailTextField}
                      type="text"
                      label="Email"
                      helpText="Email"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        EmailCheck(e)
                      }
                    />
                  </Col>

                  <Col md="4">
                    <Field
                      name="businessEmailType"
                      component={ValidateSelectField}
                      type="text"
                      label="Email Type"
                      values={emailType}
                      helpText="emailType"

                      // disabled={disableAddress}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col
                    md="6"
                    className="phoneFiled"
                    style={{ paddingRight: "0" }}
                  >
                    {
                      <Field
                        name="businessPhoneNumber"
                        component={PhoneNumberField}
                        type="text"
                        label="Phone Number "
                        helpText="PhoneNumber"
                      />
                    }
                  </Col>

                  <Col md="2" className="phExt" style={{ paddingRight: "0" }}>
                    <Field
                      name="businessPhoneExt"
                      component={TextField}
                      type="text"
                      label="Ext."
                      helpText="Ext"
                      normalize={NormaliseExt}
                    />
                  </Col>

                  <Col md="4" className="phoneType">
                    <Field
                      name="businessPhoneType"
                      component={ValidateSelectField}
                      type="text"
                      label="Phone Type"
                      helpText="phoneType"
                      values={phoneType}

                      //isRequired ={props?.formValues?.businessPhoneNumber?true:false}

                      // disabled={disableAddress}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </CardBody>

          <div className="contact-save">
            <Button
              className="save-button"
              disabled={props.invalid}
              type="submit"
            >
              Save
            </Button>
          </div>
        </Card>
      </form>
    </>
  );
};

const mapStateToProps = (state: any, props: any) => ({
  initialValues: props.data, // retrieve name from redux store

  formValues: getFormValues("EditCompanyInfoForm")(state),
});

export default connect(mapStateToProps)(
  reduxForm<Record<string, unknown>, any>({
    form: "EditCompanyInfoForm",

    enableReinitialize: true,

    validate,

    warn,
  })(EditCompanyInfoForm)
);
